// api
import axioApi, { setHeader } from 'api/root.api';

export const modelLight = async (body, token, projectId, modelId)=>{
    const urlEnd = `/editor/project/v1/${projectId}/${modelId}/shadowCard`;
    setHeader('Authorization', `Bearer ${token}`);
    const response = await axioApi.post(urlEnd, body);
    const result = response.data;
    return result;
};